import { isNodeVisible } from './isNodeVisible';

const traverse = (
  nodeId: string,
  node: BaseNode,
  depth: number
): BaseNode | null => {
  if (!isNodeVisible(node)) return null;

  if (nodeId === node.id) return node;

  if (!('children' in node)) return null;

  if (depth > 0) {
    for (const childNode of node.children) {
      const found = traverse(nodeId, childNode, depth - 1);

      if (found) return found;
    }
  }

  return null;
};

export const findNodeById = (
  nodeId: string,
  container: BaseNode,
  depth = 1
): BaseNode | null => {
  if (!nodeId) return null;

  if (container.id === nodeId) return container;

  return traverse(nodeId, container, depth);
};
